import React,{useEffect,useState} from 'react'
import './message.scss';
import Brand from '../brand/Brand';
import { Speaker } from '../models/enum';
import { MessageModel } from '../models/messageModel';
import { handleAnalyticsBot, isMobileOS } from '../../widget/util/commonUtil'

type messageProps = {
    message: MessageModel,
    isHostDevice: boolean ,
    messageListArray: MessageModel[],
    setShowVerifyAge: (type: boolean) => void,
    setisOverlayScreenMounted: (type: boolean) => void,
};

const Message = ({message, isHostDevice, messageListArray, setShowVerifyAge,setisOverlayScreenMounted}: messageProps) => {
    const [addMessageClass, setAddMessageClass] = useState('');
    const [addMargin, setAddMargin] = useState('large-margin');
    const [showVerifyAgeMessage, setShowVerifyAgeMessage] = useState<boolean>(false);

    const clickHandler = () => {
        handleAnalyticsBot(`${isMobileOS() ? 'app' : 'web'}:chatbot:nsw id verification:read whats changing`, 'chatbot nsw id verification', 'chatbotTriggerAdobeAnalytics');
        setShowVerifyAge(true)
        setisOverlayScreenMounted(true)
    } 

    useEffect(() => {
        messageListArray.push(message);
        const len = messageListArray.length;
        if(message.hasOwnProperty('isVerifyAge')){
            setShowVerifyAgeMessage(true);
        }
        
        if (len > 1) {
            const prev = messageListArray[len - 2];
    
            if (message.from === 'user' || message.from === 'bws') {
                if (!prev?.from) {
                    setAddMargin('large-margin')
                } else if (prev.from === 'user') {
                    setAddMargin('user-message-margin');
                }
            } else if (!message.from) {
                if ((!prev?.from && !prev?.hasQr) || prev.from === 'bws') {
                    setAddMargin('small-margin')
                } else {
                    setAddMargin('large-margin');
                }
            }
        }
    
        if (message.from !== 'user' && message !== null && message.from !== Speaker.System) setAddMessageClass('message__text--bot');

    }, []);
    
    return (
        <div className={"message " + " " + addMessageClass + " " + addMargin + " " + (message.isFirstBotMessageInConversation ? '' : 'round-message')}>
      
            {message.showBotLabel && (
                <div className='message__brand--container'>
                    <Brand size='small'/>
                    <span className='message__brand-label'>BWS BOT</span>
                </div>)
            }

            {showVerifyAgeMessage && 
                <div className='verify-age'>
                    <img src={message.icon} alt="" />
                    <div className='verify-age--text'>
                        <span>{message.text}</span>
                        <button onClick={clickHandler}>read what's changing</button>
                    </div>
                </div>
            }

            <div className={message.hasQr && !isHostDevice ? "message__container message__container--has-qr" : "message__container"}> 
                {
                    message.from === Speaker.System &&  !showVerifyAgeMessage &&
               
                    <div className="message__system">
                        
                        { message.icon && message.icon !== '' && <img src={ message.icon } className="message__system-icon" alt="system-icon" /> } 
                        <span className="message__system-text">
                        <span>
                            { message.text }
                            {
                                message.shopper && message.shopper !== '' &&
                                <b>&nbsp;{ message.shopper }</b> 
                            }
                        </span>
                        </span>
                    </div>
                }

                {
                    message.from === Speaker.User &&
                    <div className="message__text message__text--user">
                        { message.text }
                    </div>
                }

                {
                    (message.from === Speaker.BWS || message.from === Speaker.Agent || message.from === undefined || message.from === null) &&
                    <div className="message__text">
                        { message.text }
                    </div>
                }
            </div>
        </div>
    )
}

export default Message